<div
  click-stop-propagation
  class="info"
  [ngStyle]="{
    'background-color': option.backgroundColor,
    margin: option.margin,
  }"
>
  @if (option.icon) {
    <pr-icon
      [name]="option.icon"
      [width]="option.iconWidth"
      [height]="option.iconHeight"
      class="info__icon"
      [ngStyle]="{ color: option.iconColor }"
    ></pr-icon>
  }
  <p
    class="info__text"
    [ngStyle]="{
      color: option.textColor,
      'text-decoration': option.textDecoration,
    }"
  >
    <ng-content></ng-content>
  </p>
</div>
